export default {
        // "edgeComputing_getBatchEdgeComputingRules": "查询边缘计算成功",
        "edgeComputing_getBatchEdgeComputingRules": {
                default: '查询边缘计算成功',
                custom1: '成功查询'
        },
}